var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpGoodsimageActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#A3D7FF;}\r\n\t.st2{fill:#006EFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384,832h256l0,0v112c0,8.8-7.2,16-16,16H400c-8.8,0-16-7.2-16-16V832L384,832z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512,64c-89.3,0.1-177.2,22.1-256,64l64,256l64,384h256l64-384l64-256C689.2,86.1,601.3,64.1,512,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M796,741.6l110.9,43.8c4.1,1.6,6.1,6.3,4.5,10.4c-0.8,2.1-2.4,3.7-4.5,4.5L796,844l-43.8,110.9 c-1.6,4.1-6.3,6.1-10.4,4.5c-2.1-0.8-3.7-2.4-4.5-4.5L693.6,844l-110.9-43.8c-4.1-1.6-6.1-6.3-4.5-10.4c0.8-2.1,2.4-3.7,4.5-4.5 l110.9-43.8l43.8-110.9c1.6-4.1,6.3-6.1,10.4-4.5c2.1,0.8,3.7,2.4,4.5,4.5L796,741.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M806.4,142l72.9,28.8c4.1,1.6,6.1,6.3,4.5,10.4c-0.8,2.1-2.4,3.7-4.5,4.5l-72.9,28.8l-28.8,72.9 c-1.6,4.1-6.3,6.1-10.4,4.5c-2.1-0.8-3.7-2.4-4.5-4.5L734,214.4l-72.9-28.8c-4.1-1.6-6.1-6.3-4.5-10.4c0.8-2.1,2.4-3.7,4.5-4.5 L734,142l28.8-72.9c1.6-4.1,6.3-6.1,10.4-4.5c2.1,0.8,3.7,2.4,4.5,4.5L806.4,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M262.4,361.6l72.9,28.8c4.1,1.6,6.1,6.3,4.5,10.4c-0.8,2.1-2.4,3.7-4.5,4.5L262.4,434l-28.8,72.9 c-1.6,4.1-6.3,6.1-10.4,4.5c-2.1-0.8-3.7-2.4-4.5-4.5L190,434l-72.9-28.8c-4.1-1.6-6.1-6.3-4.5-10.4c0.8-2.1,2.4-3.7,4.5-4.5 l72.9-28.8l28.8-72.9c1.6-4.1,6.3-6.1,10.4-4.5c2.1,0.8,3.7,2.4,4.5,4.5L262.4,361.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpGoodsimageActive);
export default __webpack_public_path__ + "static/media/hp_goodsimage_active.ada3a3969dda9bd958e94b8518c8693b.svg";
export { ForwardRef as ReactComponent };